// extracted by mini-css-extract-plugin
export default {"root":"CaseStatistics_root__i9aY5","grid":"CaseStatistics_grid__JCMSL"};